{
  "Accessibility Menu": "Tillgänglighetsmeny",
  "Reset settings": "Nollställ inställningar",
  "Close": "Stäng",
  "Content Adjustments": "Anpassa innehåll",
  "Adjust Font Size": "Justera textstorlek",
  "Highlight Title": "Framhäv titel",
  "Highlight Links": "Framhäv länkar",
  "Readable Font": "Läsbart teckensnitt",
  "Color Adjustments": "Anpassa färger",
  "Dark Contrast": "Mörk kontrast",
  "Light Contrast": "Ljus kontrast",
  "High Contrast": "Hög kontrast",
  "High Saturation": "Hög mättnad",
  "Low Saturation": "Låg mättnad",
  "Monochrome": "Monokrom",
  "Tools": "Verktyg",
  "Reading Guide": "Läslinjal",
  "Stop Animations": "Hindra animationer",
  "Big Cursor": "Stor muspekare",
  "Increase Font Size": "Öka textstorlek",
  "Decrease Font Size": "Minska textstorlek",
  "Letter Spacing": "Teckenavstånd",
  "Line Height": "Radhöjd",
  "Font Weight": "Teckensnitt tjocklek",
  "Dyslexia Font": "Dyslektiskt teckensnitt",
  "Language": "Språk",
  "Open Accessibility Menu": "Öppna tillgänglighetsmeny"
}